const excel = require('./excel');
const strings = require('./strings');
const dataSheet = require('./dataSheet');

module.exports = {
  ...excel,
  ...strings,
  ...dataSheet,
};
